import React from 'react';
import { Link } from '@reach/router';
import RatingOptions from '../RatingOptions';
import { Button } from '@squirrellearningltd/go-pupil-components';
import { useTranslation } from 'react-i18next';
import styles from '../../Completed.module.scss';

const MyReview = ({ review, bookTitle }) => {
    const { t } = useTranslation();

    return (
        <div className={styles.myReview}>
            <h2 className={styles.myReviewTitle}>{t('your_review_is_submitted')}</h2>
            <p className={styles.myReviewSubtitle}>{t('you_rated_book', { bookTitle })}</p>
            <div className={styles.myReviewStars}>
                <RatingOptions
                    rating={review.reviewRate}
                    displayOnly
                    hideLabel
                />
            </div>
            <Link to='/'>
                <Button className={styles.myReviewButton} primary>{t('back_to_library')}</Button>
            </Link>
        </div>
    )
}

export default MyReview;
